import { FlameIcon } from "lucide-react";

import { useStudyStreakQuery } from "@/hooks/queries/useStudyStreakQuery";

const DAY_LABELS = ["월", "화", "수", "목", "금", "토", "일"];
const EMPTY_ACTIVITY = Array<boolean>(14).fill(false);

export function StudyStreak() {
  const { data } = useStudyStreakQuery();

  const streak = data?.streak ?? 0;
  const activeDays = data?.activeDays ?? 0;

  const rawActivity = data?.recentActivity ?? EMPTY_ACTIVITY;

  // 14칸(2주 풀) 미만이면 앞을 빈 칸으로 채워 7열 그리드에 맞춤
  const padded =
    rawActivity.length < 14 ? [...Array<boolean>(14 - rawActivity.length).fill(false), ...rawActivity] : rawActivity;

  return (
    <div className="rounded-xl bg-card p-5">
      <div className="flex items-center justify-between mb-4">
        <div className="flex flex-col gap-0.5">
          <p className="text-sm font-semibold text-foreground">연속 학습</p>
          <p className="text-xs text-muted-foreground">최근 2주</p>
        </div>

        <div className="flex items-center gap-1.5">
          <FlameIcon className={`size-5 ${streak > 0 ? "text-red-400" : "text-muted-foreground/40"}`} />
          <span className={`text-xl font-bold ${streak > 0 ? "text-red-400" : "text-muted-foreground/40"}`}>
            {streak}일
          </span>
        </div>
      </div>

      {/* 요일 헤더 */}
      <div className="grid grid-cols-7 gap-1.5 mb-1.5">
        {DAY_LABELS.map(label => (
          <span key={label} className="text-center text-[10px] text-muted-foreground">
            {label}
          </span>
        ))}
      </div>

      {/* 활동 그리드 */}
      <div className="grid grid-cols-7 gap-1.5">
        {padded.map((active, i) => (
          <div key={i} className={`aspect-square rounded-md ${active ? "bg-primary" : "bg-muted"}`} />
        ))}
      </div>

      <p className="mt-3 text-xs text-muted-foreground">
        <span className="font-medium text-foreground">{activeDays}일</span> 학습 완료
      </p>
    </div>
  );
}
